export default "__VITE_ASSET__Bes$hJAs__"